import { QK } from '@/js/consts/query-keys';
import { keepPreviousData, useQuery } from '@tanstack/vue-query';
import { computed, MaybeRefOrGetter, Ref, toValue } from 'vue';
import { searchCustomDataValues } from './customDataValueApi';

export const MIN_QUERY_LENGTH = 2;

export const useSearchCustomDataValues = (
    customDataTypeId: MaybeRefOrGetter<string>,
    query: Ref<string>
) => {
    return useQuery({
        queryKey: computed(() => [
            QK.FILTER.CUSTOM_DATA_VALUES,
            toValue(customDataTypeId),
            query.value,
        ]),
        queryFn: () => searchCustomDataValues(toValue(customDataTypeId), query.value),
        enabled: computed(() => query.value.length >= MIN_QUERY_LENGTH),
        placeholderData: keepPreviousData,
    });
};
